export default {
  computed: {
    // パスがsystem_ownersから始まる
    underSystemOwnerPage() {
      return this.$route.path.startsWith('/system_owners/')
    },
    // パスにinsertion_ordersを含む
    isIOPage() {
      return this.$route.path.includes('/insertion_orders/')
    },
    // パスがagenciesから始まる
    isAdvertiserPage() {
      return this.$route.path.startsWith('/agencies/')
    },
    // パスがadminから始まる
    underAdminPage() {
      return this.$route.path.startsWith('/admin/')
    },
    underAdminRequestPage() {
      return this.$route.path.startsWith('/admin/request/')
    },
    underAdminAccountsPage() {
      return this.$route.path.startsWith('/admin/accounts/')
    },
  },
}
